<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Work Order Supply" active>

                                <b-row v-if="hasFailedDataWorkOrderSupply">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedWorkOrderSupply.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderSupplysFailed" :fields="fieldsWorkOrderSupply" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderSupply" :sort-desc.sync="sortDescWorkOrderSupply" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(workOrderSupplyDate)="row">
													{{ row.item.workOrderSupplyDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedWorkOrderSupply.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderSupplys" :fields="fieldsWorkOrderSupply" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderSupply" :sort-desc.sync="sortDescWorkOrderSupply" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(workOrderSupplyDate)="row">
													{{ row.item.workOrderSupplyDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Work Order Supply Detail" active>

                                <b-row v-if="hasFailedDataWorkOrderSupplyDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedWorkOrderSupplyDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderSupplyDetailsFailed" :fields="fieldsWorkOrderSupplyDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderSupplyDetail" :sort-desc.sync="sortDescWorkOrderSupplyDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyPlan)="row">
													{{ Number(row.item.qtyPlan).toLocaleString() }}
												</template>
												<template #cell(qtyConsumption)="row">
													{{ Number(row.item.qtyConsumption).toLocaleString() }}
												</template>
												<template #cell(qtyTransit)="row">
													{{ Number(row.item.qtyTransit).toLocaleString() }}
												</template>
												<template #cell(qtyStock)="row">
													{{ Number(row.item.qtyStock).toLocaleString() }}
												</template>
												<template #cell(qtySupply)="row">
													{{ Number(row.item.qtySupply).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedWorkOrderSupplyDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderSupplyDetails" :fields="fieldsWorkOrderSupplyDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderSupplyDetail" :sort-desc.sync="sortDescWorkOrderSupplyDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyPlan)="row">
													{{ Number(row.item.qtyPlan).toLocaleString() }}
												</template>
												<template #cell(qtyConsumption)="row">
													{{ Number(row.item.qtyConsumption).toLocaleString() }}
												</template>
												<template #cell(qtyTransit)="row">
													{{ Number(row.item.qtyTransit).toLocaleString() }}
												</template>
												<template #cell(qtyStock)="row">
													{{ Number(row.item.qtyStock).toLocaleString() }}
												</template>
												<template #cell(qtySupply)="row">
													{{ Number(row.item.qtySupply).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderSupplyList from '@/models/WorkOrderSupply/WorkOrderSupplyList';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsWorkOrderSupply: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process Number", key: 'workOrderProcessWorkOrderProcessNumber', sortable: false},
				{"class" : "th-status", "label" : "WorkOrderSupplyDate", key: 'workOrderSupplyDate', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},
				{"class" : "th-status", "label" : "Line", key: 'lineCode', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsWorkOrderSupplyDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Number - Name", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Material Part Number", key: 'materialPartPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process Detail", key: 'workOrderProcessDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Bill Of Material Detail", key: 'billOfMaterialDetailPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Customer", key: 'customerCode', sortable: false},
				{"class" : "th-status", "label" : "Qty Plan", key: 'qtyPlan', sortable: false},
				{"class" : "th-status", "label" : "Qty Consumption", key: 'qtyConsumption', sortable: false},
				{"class" : "th-status", "label" : "Qty Transit", key: 'qtyTransit', sortable: false},
				{"class" : "th-status", "label" : "Qty Stock", key: 'qtyStock', sortable: false},
				{"class" : "th-status", "label" : "Qty Supply", key: 'qtySupply', sortable: false},
				{"class" : "th-status", "label" : "Uom", key: 'uomCode', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			workOrderSupplys : [],
			workOrderSupplysFailed: [],
			workOrderSupplyId : '',
			sortByWorkOrderSupply: '',
			sortDescWorkOrderSupply: '',
			hasFailedDataWorkOrderSupply: false,
			totalFailedWorkOrderSupply: 0,
			totalSucceedWorkOrderSupply: 0,
			workOrderSupplyDetails : [],
			workOrderSupplyDetailsFailed: [],
			workOrderSupplyDetailId : '',
			sortByWorkOrderSupplyDetail: '',
			sortDescWorkOrderSupplyDetail: '',
			hasFailedDataWorkOrderSupplyDetail: false,
			totalFailedWorkOrderSupplyDetail: 0,
			totalSucceedWorkOrderSupplyDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('workordersupply/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('workordersupply/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getWorkOrderSupplyForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getWorkOrderSupplyForUpload : async function() {
			let _this = this;
			this.$http.get('workordersupply/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.workOrderSupplys = [];
_this.workOrderSupplyDetails = [];


					if (response != null) {
						let result = response.data;
						_this.workOrderSupplys = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedWorkOrderSupply = _this.workOrderSupplys.length;

						_this.workOrderSupplysFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataWorkOrderSupply = true;
						_this.totalFailedWorkOrderSupply = 0;
						if(_this.workOrderSupplysFailed == undefined || _this.workOrderSupplysFailed.length === 0) _this.hasFailedDataWorkOrderSupply = false;
						if(_this.hasFailedDataWorkOrderSupply) _this.totalFailedWorkOrderSupply = _this.workOrderSupplysFailed.length;
						_this.workOrderSupplyDetails = [];
						_this.workOrderSupplyDetailsFailed = [];
						_this.hasFailedDataWorkOrderSupplyDetail = true;
						_this.totalSucceedWorkOrderSupplyDetail = 0;
						result.forEach(function(element) {
							_this.workOrderSupplyDetails.push(...element.workOrderSupplyDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedWorkOrderSupplyDetail = _this.workOrderSupplyDetails.length;

							_this.workOrderSupplyDetailsFailed.push(...element.workOrderSupplyDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.workOrderSupplyDetailsFailed == undefined || _this.workOrderSupplyDetailsFailed.length === 0) _this.hasFailedDataWorkOrderSupplyDetail = false;
							if(_this.hasFailedDataWorkOrderSupplyDetail) _this.totalFailedWorkOrderSupplyDetail = _this.workOrderSupplyDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'workordersupply/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'WorkOrderSupply.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterWorkOrderSupply = new WorkOrderSupplyFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
